var cabecera = function () {
    var botonVideo = document.querySelector('.cabecera__video__enlace button');
    if (!botonVideo) {
        return;
    }
    var modal = document.querySelector('.cabecera__video');
    var cerrar = modal.querySelector('.cabecera__video__cerrar');
    var cierraModal = function () {
        modal.close();
        modal.remove();
    };
    botonVideo.addEventListener('click', function () {
        document.documentElement.appendChild(modal);
        modal.showModal();
    });
    cerrar.addEventListener('click', cierraModal);
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            cierraModal();
        }
    });
    modal.remove();
};
export default cabecera;
